import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { useState } from "react";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { QData } from "../../../types/basic-type-list";
import { TResponseWithQData } from "../../../types/common";
import { ITransactionPopulated} from "../../../types/api/transaction";
import { transactionList } from "./callbacks";

export const useTransactionList = (
  qData: QData,
  options?: Omit<
    UseQueryOptions<TResponseWithQData<ITransactionPopulated[]>, Error>,
    "queryKey" | "queryFn"
  >
): UseQueryResult<TResponseWithQData<ITransactionPopulated[]>, Error> & {
  refetchWithQuery: (params: Partial<QData>) => void;
} => {
  const [queryParams, setQueryParams] = useState<QData>({ ...qData });
  const queryResult = useQuery<TResponseWithQData<ITransactionPopulated[]>, Error>(
    {
      queryKey: [API_ENDPOINTS.FILLING_MANAGEMENT_LIST, { ...queryParams, total: null }],
      queryFn: async () => {
        const res = await transactionList(queryParams);
        return res.data;
      },
      select: (res) => ({
        ...res,
        data: res.data.map((x) => ({ key: x._id, ...x })),
        qData: { ...queryParams, total: res.extra?.total },
      }),
      staleTime: 300000,
      initialDataUpdatedAt: 0,
      refetchOnWindowFocus: true,

      ...options,
    }
  );

  return {
    ...queryResult,
    refetchWithQuery: (params: Partial<QData>) => {
      setQueryParams((prev: any) => ({ ...params }));
    },
  };
};


